import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import type {
  DiscordInfo,
  ImportHistoryItemT,
} from '@/features/Setting/Integrations/providers/types';
import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import LoadingLayout from '@/layouts/LoadingLayout';
import services from '@/services/index';
import { connectionErrorHandler } from '@/services/integrations/util';

import type { IMPORT_STATE } from '../providers/types';

export type DiscordResponse = {
  alias: string;
  name: string;
  workspace_id: string;
  state: IMPORT_STATE;
  history?: ImportHistoryItemT[];
  created_at: string;
  created_by: string;
  isDuplicated?: boolean;
};

const DiscordRedirect = () => {
  const [, setRedirect] = useCrossWindowState<DiscordInfo | null>(
    'discord-redirect',
    null,
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && state) {
      const workspaceAlias = state;
      const asyncUpdateHandler = async () => {
        try {
          const discord = await services.discord.createDiscordInfo(
            code,
            workspaceAlias,
            `${window.location.origin}/discord`,
          );
          if (discord.isDuplicated) {
            navigate('/discord-fail', { replace: true });
          } else {
            setRedirect(discord);
            window.close();
          }
        } catch (e) {
          console.error(connectionErrorHandler(e));
          navigate('/500', { replace: true });
        }
      };
      asyncUpdateHandler();
    }
  }, [setRedirect, navigate, searchParams]);

  return <LoadingLayout>Connecting this discord...</LoadingLayout>;
};

export default DiscordRedirect;
